/**
 * DSK Quick Buttons Widget Configuration
 * Този файл съдържа конфигурация за DSK Quick Buttons Widget
 * Може да се променя лесно без да се променя компонентът
 */

import { getSiteConfig } from './sites';

const site = getSiteConfig();

export const DSK_QUICK_BUTTONS_CONFIG = {
  // Script URL за зареждане на pay-buttons.js
  scriptUrl:
    process.env.NEXT_PUBLIC_DSK_WIDGET_SCRIPT_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://epg.dskbank.bg/payment/pay-buttons/pay-buttons.js'
      : 'https://uat.dskbank.bg/payment/pay-buttons/pay-buttons.js'),

  // Merchant Token (от .env.local)
  merchantToken: process.env.NEXT_PUBLIC_DSK_MERCHANT_TOKEN,

  // Merchant credentials (от site config)
  merchantLogin: site.payment.merchantLogin,
  merchantName: site.payment.merchantName,

  // Default currency (978 = EUR, 975 = BGN, 840 = USD)
  defaultCurrency: site.payment.currency,

  // Language
  language: 'BG',

  // Apple Pay настройки
  applePay: {
    paymentType: 'plain', // Type of payment button appearance (според новия скрипт)
    buttonStyle: 'white-outline', // Button display style - променено на 'white-outline' според новия скрипт
    countryCode: 'BG', // За paymentRequest.countryCode (BG вместо NL според нашия случай)
    supportedNetworks: ['masterCard', 'visa', 'electron', 'maestro'], // За paymentRequest
    merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'], // За paymentRequest
  },

  // Google Pay настройки
  googlePay: {
    buttonColor: 'white', // Button color - променено на 'white' според новия скрипт
    buttonType: 'short', // Button type - променено на 'short' според новия скрипт
    payerNameRequired: false, // Request buyer's name
    billingAddressRequired: true, // Request buyer's postal address
  },
};
